/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PromotionPrecheckResponseApplicationAnswers } from './promotionPrecheckResponseApplicationAnswers';
import type { RequiredApplicationField } from './requiredApplicationField';

export interface PromotionPrecheckResponse {
  applies: boolean;
  allowed: boolean;
  missing_fields?: string[];
  email_state?: string;
  name_required?: boolean;
  screening_questions_required?: boolean;
  application_questions_incomplete?: boolean;
  application_questions_soft_hint?: boolean;
  ats_display_name?: string | null;
  required_application_fields?: RequiredApplicationField[];
  application_answers?: PromotionPrecheckResponseApplicationAnswers;
}
